import { Box, Text, BoxProps } from "@hightouch/htui";

export const LoaderText = ({
  children = "Loading chart",
  ...props
}: {
  children?: string;
} & Omit<BoxProps, "as" | "children" | "color">) => {
  return (
    <Box as={Text} size="sm" color="text.secondary" {...props}>
      {children}...
    </Box>
  );
};
